import { gql } from "@apollo/client";

export default gql`
  query getChangelogWhatsAppTemplates($input: ChangelogWhatsAppTemplatesInput!){
    getChangelogWhatsAppTemplates(input: $input){
        success
        data
        error
        message
    }
}
`
